export default __webpack_public_path__ + "img/caret-up-white.99aed714.svg";